<template>
	<div class="bl-form-field-multimodel-container">
		<BlSelect ref="field" :data="choices ? choices : field.options.choices" :loading="!field.options.loadAll" :errored="field.isErrored() && field.getTouched()" :label="field.label" v-model="model" @change="field.setValue(model)" @focus="loadValues()" multiple="true" :specialChoices="specialChoices" :tabindex="tabindex" :preferredChoices="field.options.preferredChoices" />
	</div>
</template>

<script>

import { Dialog, Router } from 'InterfaceBundle'
import { FormEvents } from 'FormBundle'

export default {
	name: 'BlFormFieldMultimodel',
	inject: ['blFormLiveUpdateFields', 'blForm'],
	props: ['field', 'tabindex'],
	data() {
		return {
			model: null,
			loaded: false,
			specialChoices: null
		}
	},
	watch: {
		'field.options.autoSelectValue'() {
			if(this.field.options.autoSelectValue) {
				this.field.setValue(this.field.options.autoSelectValue)
				this.model = this.field.options.autoSelectValue
			}
		}
	},
	methods: {
		loadValues() {
			this.field.setTouched()
			if(!this.loaded) {
				this.loaded = true
				this.reloadValues().catch(() => {
					const options = this.field.options
					options.loadAll = false
					this.loaded = false
				})
			}
		},
		reloadValues() {
			let req = {}
			req[this.field.getQualifiedName()] = {loadAll: true}
			return this.blFormLiveUpdateFields(req)
		},
		setModel() {
			this.model = JSON.parse(JSON.stringify(this.field.value))
		}
	},
	created() {
		this.setModel()
		if(this.field.options.newitem) this.specialChoices = [{label: this.$t('form.createItem'), value: search => {
			//Parse option
			let component = this.field.options.newitem.split(':')
			let field = null
			let propName = null
			if(component.length >= 2) field = component[1]
			if(component.length >= 3) propName = component[2]
			component = component[0]

			//Handle form submission
			let submitSub = FormEvents.submitted.once(response => {
				this.reloadValues().then(() => {
					this.field.setValue(this.field.value.concat([response.__id]))
					this.setModel()
				})
				Dialog.close(false)
			})

			//Initialize value if required
			let readySub = (search && field) ? FormEvents.ready.once(form => form.form.getChild(field).setValue(search)) : null

			//Create dialog
			let matchingRoutes = Router.routes.filter(r => r.component == component)
			FormEvents.disableRouting = true
			let childProps = {}
			if(propName) childProps[propName] = this.field.root
			Dialog.custom({
				component: component,
				componentProps: childProps,
				title: matchingRoutes.length ? matchingRoutes[0].title : '',
				required: true,
				closeButton: true
			}).catch(() => {
				FormEvents.disableRouting = false
				if(readySub) readySub.unsubscribe()
				submitSub.unsubscribe()
			})
		}}]
		this.field.emitter.focus.subscribe(() => this.$refs.field.$refs.searchInput.focus())
		this.field.emitter.change.subscribe(() => this.setModel())
		document.addEventListener('keydown', event => {
			if(this.$el.contains(document.activeElement) && event.key === 'F' && event.ctrlKey === true && event.shiftKey === true) this.reloadValues()
		})
	}
}
</script>

<style lang="scss">
div.bl-form-field-multimodel-container {
	margin-top: 15px;
}

.bl-formtable div.bl-form-field-multimodel-container {
	margin-top: 0;
}
</style>